import { render, staticRenderFns } from "./ScamAlertNotice.vue?vue&type=template&id=174b94e5&"
import script from "./ScamAlertNotice.vue?vue&type=script&lang=js&"
export * from "./ScamAlertNotice.vue?vue&type=script&lang=js&"
import style0 from "./ScamAlertNotice.vue?vue&type=style&index=0&id=174b94e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports